import React from "react";
import { connect } from "react-redux";
import { actions as routerActions } from "redux-router5";

import * as Routes from "../routing/routes";
import LayoutWithFooter from "../page/layout-with-footer";
import AppSecondaryBackground from "../root/app-secondary-background";
import PageHeader from "../page/page-header";
import { getBrand } from "../brand/brand-selectors";
import SelfDiagnosticFinished from "../general-info/self-diagnostic-finished";

function SelfDiagnosticFinishedPage({ goTo, brand }) {
  return (
    <AppSecondaryBackground>
      <LayoutWithFooter className="SelfDiagnosticFinished SelfDiagnosticFinishedPage">
        <PageHeader
          className={"SelfDiagnosticFinishedPage__Header"}
          logo={brand.imagePost}
        />
        <SelfDiagnosticFinished
          onNext={() => goTo(Routes.CONSENT)}
          brand={brand}
        />
      </LayoutWithFooter>
    </AppSecondaryBackground>
  );
}

const mapState = state => ({
  brand: getBrand(state)
});
const mapDispatch = {
  goTo: routerActions.navigateTo
};

SelfDiagnosticFinishedPage = connect(
  mapState,
  mapDispatch
)(SelfDiagnosticFinishedPage);

export default SelfDiagnosticFinishedPage;



// WEBPACK FOOTER //
// ./src/modules/pages/SelfDiagnosticFinishedPage.js